import { render, staticRenderFns } from "./zhiboclass.vue?vue&type=template&id=bee1d18c&scoped=true"
import script from "./zhiboclass.vue?vue&type=script&lang=js"
export * from "./zhiboclass.vue?vue&type=script&lang=js"
import style0 from "./zhiboclass.vue?vue&type=style&index=0&id=bee1d18c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1d18c",
  null
  
)

export default component.exports